import React from "react";
import { Result } from "antd";

import { i18, trb } from "@utilities";

export const Content404 = () => {
  return (
    <div className="w-100">
      <Result status="404" title="404" subTitle={trb(i18.Messages.PageDoesntExist)} />
    </div>
  );
};
